import { Outlet } from 'react-router-dom'
import { LogoutButton } from '../../components/Buttons/LogoutButton'
import { HeaderLayout } from '../../layouts/HeaderLayout'

export const MarketPlaceLayout = () => (
    <HeaderLayout header={{ right: <LogoutButton /> }} main={<Outlet />} />
)
